import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sentiment-actionable-comments-card',
  standalone: false,
  templateUrl: './actionable-comments-card.component.html',
  styleUrls: ['./actionable-comments-card.component.scss'],
})
export class SentimentActionableCommentsCardComponent {
  @Input() count: number = 0;
  @Input() label: string = 'Actionable comments';
}
